import React from 'react';
import './Concept.css';
import dec_img from '../../img/main/bg.gif'
import text from '../../img/concept/text.svg'
import { Link } from "react-scroll";

const Concept = () => {
    return (
        <div className="concept-wrap" id='concept'>
            <div className="container concept">
                <h2 className='concept-title colorful'>Idea and concept</h2>
                <div className="concept-content">
                    <div className='concept-content_main'>
                        <img className="concept-img concept-item" src={dec_img} alt="" />
                        <div className='concept-text--block concept-item'>
                            <img src={text} alt="" />
                            {/* <Link
                                activeClass="active"
                                to='tickets'
                                spy={true}
                                smooth={true}
                                offset={-94}
                                className='concept-btn button'
                            >
                                Join
                            </Link> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Concept;